import { Die } from './types';
import { DiceType } from '../models/DiceModel';

// 生成1-6之间的随机数
export const rollDie = (): number => {
  return Math.floor(Math.random() * 6) + 1;
};

// 初始化骰子
export const initializeDice = (count: number = 6): Die[] => {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    value: rollDie(),
    selected: false,
    locked: false,
    type: DiceType.NORMAL
  }));
};
